function updatePendoGuides(disabled: boolean): void {
  if (typeof pendo === "undefined" || !pendo) return;

  setTimeout(() => {
    try {
      pendo.setGuidesDisabled(disabled);
      if (disabled) {
        pendo.stopGuides?.();
      } else {
        pendo.loadGuides?.();
      }
    } catch (e) {
      console.error(
        `[Pendo] Error ${disabled ? "disabling" : "enabling"} guides:`,
        e,
      );
    }
  }, 500);
}

export function enablePendoGuides(): void {
  updatePendoGuides(false);
}

export function disablePendoGuides(): void {
  updatePendoGuides(true);
}
